/* Click-to-play inline on desktop and mobile; no modal or background autoplay. */
if (!customElements.get('tulip-unboxing-player')) {
  customElements.define('tulip-unboxing-player', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      const play = () => {
        if (this.querySelector('.tulip-unboxing__inline')) return;
        const source = this.querySelector('template').content.querySelector('iframe');
        if (!source) return;
        const iframe = source.cloneNode(true);
        iframe.title = this.querySelector('.tulip-unboxing__poster').getAttribute('aria-label');
        const url = new URL(iframe.src);
        url.searchParams.set('playsinline', '1');
        url.searchParams.set('autoplay', '1');
        iframe.src = url.toString();
        const inline = document.createElement('div');
        inline.className = 'tulip-unboxing__inline';
        inline.append(iframe);
        const poster = this.querySelector('.tulip-unboxing__poster');
        poster.after(inline);
        poster.hidden = true;
        this.querySelector('.tulip-unboxing__watch').hidden = true;
        iframe.focus({preventScroll:true});
      };
      this.querySelectorAll('[data-unboxing-play]').forEach(button => button.addEventListener('click', play));
    }
  });
}
